<script>

    import { shipmentsStore, modalStore } from '../stores'

    import TrackingsService from '../$services/trackings.service'
    import DateMethod from '../$methods/date.method'

    import ModalContainer from '../$components/modal.container.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let trackingsTotal = 0
    let shipmentInfo = null

    async function updateTrackings() {

        trackingsTotal = 0

        modalStore.open('tracking_automatic_modal')

        for(let i = 0; i < $shipmentsStore.length; i++) {
            const shipment = $shipmentsStore[i]
            await getTracking(shipment)
        }
    }

    async function getTracking(shipment) {

        trackingsTotal += 1
        shipmentInfo = shipment

        if(shipment.provider === 'DFExpress')
            return shipment

        loading = true
        const resp = await TrackingsService.getTracking(shipment._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(resp.trackingStatus)
            shipment.trackingStatus = resp.trackingStatus

        shipment.tracking = resp.data
        shipmentsStore.replace(shipment)

        return shipment
    }

</script>

<ModalContainer id="tracking_automatic_modal">
    <div class="is-flex is-justify-content-flex-start is-align-items-center">
        <div>
            <div class="subtitle">Actualizando tracking</div>
            <div class="title">{ trackingsTotal } de { $shipmentsStore.length }</div>
        </div>
        {#if shipmentInfo}
            <div>
                <div class="subtitle">{ shipmentInfo.provider } { shipmentInfo.service }</div>
                <div class="title">{ shipmentInfo.guide }</div>
                <div class="subtitle is-6">{ DateMethod.dateTimeLarge(shipmentInfo.created) }</div>
            </div>
        {/if}
    </div>
    <div class="is-flex is-justify-content-center is-align-items-center">
        {#if trackingsTotal >= $shipmentsStore.length}
            <div class="title">Finalizado</div>
        {/if}
        <Spinner {loading} />
    </div>
</ModalContainer>

<Button on:click={updateTrackings} icon="sync" text="Actualizar tracking" />